import LoadingDots from './LoadingDots';

const Button = ({ label, type, disabled, loading, className }) => {
  const setDisabled = () => loading || disabled;
  return (
    <button
      disabled={setDisabled()}
      type={type || 'submit'}
      className={`mg-btn mg-btn--primary mg-btn--block mb-3 ${className || ''}`}
    >
      {loading ? <LoadingDots /> : <span className="btn__text">{label}</span>}
    </button>
  );
};

export default Button;
